import React from 'react';
import PropTypes from 'prop-types';
import * as formatter from 'mt-react-common/utils/formatter';
import { Link } from 'react-router-dom';

import SpecPagesTags from '../Common/SpecPagesTags';

const SpecialPagesListItem = props => (
  <div className="container">
    <article className="panel panel-default panel-body_padding-large">
      <div className="panel-body">
        <div className="paper">
          <header>
            <h2 className="h1">
              <Link to={`/spec/${props.item.seo_url}`}>{props.item.title}</Link>
            </h2>
            <p className="lead">{props.item.title2}</p>
            <div className="meta">
              <small>{formatter.dateFormat7(props.item.createdAt)}</small>
              {props.item.pageTags && props.item.pageTags.length > 0 ? (
                <React.Fragment>
                  {'· '}
                  <SpecPagesTags pageTags={props.item.pageTags} />
                </React.Fragment>
              ) : null}
            </div>
          </header>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: props.item.lead }}
          />
          <div className="m-b-10">
            <Link to={`/spec/${props.item.seo_url}`}>Читать дальше</Link>
          </div>
        </div>
      </div>
    </article>
  </div>
);

SpecialPagesListItem.propTypes = {
  // CONNECT STATES
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    title2: PropTypes.string.isRequired,
    seo_url: PropTypes.string.isRequired,
    lead: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    pageTags: PropTypes.arrayOf(PropTypes.shape).isRequired
  }).isRequired
};

export default SpecialPagesListItem;



// WEBPACK FOOTER //
// ./src/components/SpecialPages/SpecialPagesList/SpecialPagesListItem.js